
import { useEffect, useState, useRef } from 'react';

export default function WhyFounder() {
  const [animated, setAnimated] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setAnimated(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const needs = [
    'Use it daily',
    'Tell us what works',
    "Tell us what doesn't",
    'Help us build the right features',
  ];

  return (
    <section ref={sectionRef} className="relative py-16 sm:py-20 lg:py-32 bg-white">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center space-y-8 sm:space-y-12">
          <h2
            className={`font-harvey-serif text-[#09090b] text-[32px] sm:text-[42px] lg:text-[52px] font-normal tracking-tight leading-tight transition-all duration-700 ${
              animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
            }`}
          >
            Why Founder Pricing
          </h2>

          <div
            className={`max-w-[800px] mx-auto space-y-6 sm:space-y-8 transition-all duration-700 delay-200 ${
              animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            <p className="font-harvey-sans text-[#52525b] text-base sm:text-lg lg:text-xl font-light tracking-wide leading-relaxed">
              We need founding members who will:
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
              {needs.map((need, index) => (
                <div
                  key={index}
                  className={`p-4 sm:p-6 bg-[#f5f0e8] border border-[#e8dcc8] rounded-xl transition-all duration-700 hover:border-[#8B4513] ${
                    animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                  }`}
                  style={{ transitionDelay: `${300 + index * 100}ms` }}
                >
                  <div className="flex items-start gap-3">
                    <span className="text-[#8B4513] text-lg sm:text-xl mt-0.5">✓</span>
                    <p className="font-harvey-sans text-[#09090b] text-sm sm:text-base lg:text-lg font-normal tracking-wide">{need}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="pt-6 sm:pt-8 space-y-4 sm:space-y-6">
              <p className="font-harvey-sans text-[#52525b] text-base sm:text-lg lg:text-xl font-light tracking-wide leading-relaxed">
                In exchange, you get the lowest price we'll ever charge. <span className="text-[#d4af37] font-medium">Locked in. Forever.</span>
              </p>

              <p className="font-harvey-sans text-[#09090b] text-lg sm:text-xl lg:text-2xl font-normal tracking-wide">
                Even when we're charging $149/month. Even when we're charging $299/month.{' '}
                <span className="text-[#d4af37] font-medium">Your rate stays $25.</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
